var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.99 10.187c0-.82-.069-1.417-.216-2.037H10.2v3.698h5.62c-.113.92-.725 2.303-2.084 3.233l-.02.124 3.028 2.292.21.02c1.926-1.738 3.037-4.296 3.037-7.33Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 19.931c2.754 0 5.065-.886 6.754-2.414l-3.218-2.436c-.862.587-2.017.997-3.536.997A6.126 6.126 0 0 1 4.4 11.937l-.12.01-3.148 2.38-.041.112c1.677 3.255 5.122 5.492 9.11 5.492Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.396 11.937a6.009 6.009 0 0 1-.34-1.971c0-.687.125-1.351.33-1.971l-.007-.132-3.187-2.42-.104.05A9.79 9.79 0 0 0 0 9.965a9.79 9.79 0 0 0 1.088 4.473l3.308-2.502Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 3.853c1.915 0 3.207.809 3.944 1.484l2.878-2.746C15.254.985 12.954 0 10.2 0 6.212 0 2.767 2.237 1.09 5.492l3.297 2.503A6.152 6.152 0 0 1 10.2 3.853Z",
    fill: "#EB4335"
  })));
};
export default SvgGoogle;